/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "The form could not be loaded. Please try again." |
*
* @param {Spaces_Credentials_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_load_error = /** @type {((inputs?: Spaces_Credentials_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Formular konnte nicht geladen werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("The form could not be loaded. Please try again.")
});